import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}
export const InfoCallout = ({ label }: Props) => (
  <Alert color="info">
    <Box flexDirection="row" gap="s6">
      <Icon.Medium icon="lightbulb" color="viridian1200" />
      <Text.Normal color="black">{label}</Text.Normal>
    </Box>
  </Alert>
)
